module.exports = __webpack_public_path__ + "static/img/en-IN.f3a60ba3.svg";